import React from 'react';
import FormInput from 'src/components/form-input';

interface IProps {
  values: {
    powerCableLength?: number;
  };
  setValues: (
    value:
      | {
          powerCableLength?: number;
        }
      | ((prev: { powerCableLength?: number }) => {
          powerCableLength?: number;
        }),
  ) => void;
}

export default function EditPowerCable({ values, setValues }: IProps) {
  const length = values.powerCableLength ?? 0;

  return (
    <div className="mt-4 grid grid-cols-1 gap-4">
      <FormInput
        id="power-cable-length"
        name="powerCableLength"
        label="Power cable length (m)"
        type="number"
        wrapperClassName="w-full"
        className="w-full"
        min="0"
        step="1"
        value={String(Math.floor(Number(length)))}
        data-testid="power-cable-length-input"
        onChange={(e) => {
          const raw = e.target.value;
          const parsed = raw === '' ? 0 : Math.max(0, parseInt(raw, 10) || 0);
          setValues({
            powerCableLength: parsed,
          });
        }}
      />
    </div>
  );
}
